import type { PredictionsWidgetLocation } from '../../analyticsEvents';

export const WIDGET_LOCATION: PredictionsWidgetLocation = 'Home';
